import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AssignedContentByUser = createApi({
  reducerPath: "assignedContentByUserApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAssignedContentByUser: builder.query({
      query: ({ id, pageNumber }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            assignLearningForUserId(
              userId: "${id}"
              pageNumber: ${pageNumber}
              pageSize: 10
              sortKey: "_score"
              sortOrder: "DESC"
              relevance: true
              includeEvent: false
            ) {
              error
              data {
                totalCount
                searchResult {
                  id
                  title
                  updatedby
                  branding {
                    promo
                    thumbnail
                    banner
                  }
                  language
                  stakeholder {
                    owner
                    observer
                    nominationApprover
                    reviewer
                  }
                  createdby
                  createdat
                  completedAt
                  assignedAt
                  deadlineDate
                  status
                  publishedat
                  sourcename
                  sourcetype
                  artifactid
                  artifacturl
                  artifacttype
                  assignedBy {
                    id
                    firstName
                    fullName
                    lastName                    
                    email
                  }
                  progressStatus
                  progressPercentage
                  weblink
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ endpointName }) => {
        return { endpointName };
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs?.arg?.pageNumber > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.assignLearningForUserId?.data?.searchResult,
            ...responseData.assignLearningForUserId?.data?.searchResult
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            assignLearningForUserId: {
              ...responseData.assignLearningForUserId,
              data: {
                ...responseData.assignLearningForUserId.data,
                searchResult: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useGetAssignedContentByUserQuery,
  useLazyGetAssignedContentByUserQuery
} = AssignedContentByUser;
